// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Gmxf","select":"Header_select__28qmp","clinic":"Header_clinic__28TXg"};